module.exports = __webpack_public_path__ + "img/1F1EC-1F1F1.4297802c.svg";